<template v-if="policy">
  <!--  Fallback to DefaultPolicyTile when domain is unknown-->
  <DefaultPolicyTile
    v-if="showDefaultTile || !specificPolicyTileComponentName"
    :policy="policy"
    :is-detail-header="isDetailHeader"
  />

  <!--  Use domain specific tile-->
  <component
    v-else-if="specificPolicyTileComponentName"
    :is="specificPolicyTileComponentName"
    :policy="policy"
    :is-detail-header="isDetailHeader"
  ></component>
</template>

<script setup lang="ts">
import { type PropType } from 'vue'
import type { Policy } from 'policies-api'
import DefaultPolicyTile from '@/components/policy/DefaultPolicyTile.vue'
import { getSpecificComponentTagNameForPolicy } from '@/utilsTenant/DynamicPolicyTileMapping'

const props = defineProps({
  isDetailHeader: {
    type: Boolean,
    default: false
  },
  policy: {
    type: Object as PropType<Policy>,
    required: true
  }
})

const specificTileInformation = getSpecificComponentTagNameForPolicy(props.policy)
const showDefaultTile = specificTileInformation.showDefaultTile
const specificPolicyTileComponentName = specificTileInformation.specificTileTag
</script>
